import React from "react";
import PropTypes from "prop-types";

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import QualificationAccordionSummary from './QualificationAccordionSummary';
import Stack from '@mui/material/Stack';

import MyDatePicker from 'components/Shared/MyDatePicker';
import SAVCategorieSelect from 'components/Shared/SAVCategorieSelect';
import MarquesSelect from 'components/Shared/MarquesSelect';

import QualificationTextField from 'components/Shared/QualificationTextField';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';

import dateHelper from 'utils/dateHelper';


class SavByFoussierProduit extends QualificationComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,

            [ReclamationQualificationDetailCodes.SavByFoussierCategorie]: { index: '' },
            [ReclamationQualificationDetailCodes.DetailSavTypeProduit]: props.designation,
            [ReclamationQualificationDetailCodes.DetailSavMarque]: { id: '' },
            [ReclamationQualificationDetailCodes.SavByFoussierCodeArticle]: '',
            [ReclamationQualificationDetailCodes.DetailSavNumeroSerie]: '',
            [ReclamationQualificationDetailCodes.DetailSavDateAchat]: props.dateAchat,
            [ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie]: props.dateFinGarantie,
            [ReclamationQualificationDetailCodes.DetailSavBLOuFacture]: props.blOuFacture,
            [ReclamationQualificationDetailCodes.DetailSavMotif]: '',

            anneeProductionMachine: null,
            anneeProductionMachineLisible: false,
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.SavByFoussierCategorie,
            ReclamationQualificationDetailCodes.DetailSavTypeProduit,
            ReclamationQualificationDetailCodes.DetailSavMarque,
            ReclamationQualificationDetailCodes.SavByFoussierCodeArticle,
            ReclamationQualificationDetailCodes.DetailSavNumeroSerie,
            ReclamationQualificationDetailCodes.DetailSavDateAchat,
            ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie,
            ReclamationQualificationDetailCodes.DetailSavBLOuFacture,
            ReclamationQualificationDetailCodes.DetailSavMotif,
            ReclamationQualificationDetailCodes.DetailSavAnneeProductionMachine
        ];
    }


    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");
    }


    handleChangeDateAchat = (event) => {
        const { onChange, name, delaiReference } = this.props;

        let dateFinGarantie = dateHelper.addDays(event.target.value, delaiReference);

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value,
            [ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie]: dateFinGarantie,
        };
        this.setState(newState);

        const { position, toAdd, toDelete } = this.getQualificationData(newState);

        onChange(name, position, toAdd, toDelete, "Life");
    }


    handleChangeAnneeProductionMachine = (value) => {
        const { onChange, name } = this.props;

        let newState = { ...this.state };

        if (value && typeof value === "object") {
            newState.anneeProductionMachine = value;

            newState.anneeProductionMachineLisible = false;
        }
        else if (value && typeof value === "boolean") {
            newState.anneeProductionMachineLisible = value;

            if (value) {
                newState.anneeProductionMachine = null;
            }
        }

        this.setState(newState);

        const { position, toAdd, toDelete } = this.getQualificationData(newState);

        onChange(name, position, toAdd, toDelete, "Life");
    }


    getQualificationData(newState) {

        const { nonFoussierHorsGarantie } = this.props;

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];

        if (newState[ReclamationQualificationDetailCodes.SavByFoussierCategorie] === ''
            || !newState[ReclamationQualificationDetailCodes.DetailSavTypeProduit]
            || newState[ReclamationQualificationDetailCodes.DetailSavMarque] === ''
            || !newState[ReclamationQualificationDetailCodes.SavByFoussierCodeArticle]
            || !newState[ReclamationQualificationDetailCodes.DetailSavNumeroSerie]

            || (!nonFoussierHorsGarantie && !newState[ReclamationQualificationDetailCodes.DetailSavDateAchat])
            || (!nonFoussierHorsGarantie && !newState[ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie])
            || (!nonFoussierHorsGarantie && !newState[ReclamationQualificationDetailCodes.DetailSavBLOuFacture])

            || !newState[ReclamationQualificationDetailCodes.DetailSavMotif]
            || (newState.anneeProductionMachine === null && newState.anneeProductionMachineLisible === false)
        ) {
            return {
                name: newState.name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.SavByFoussierCategorie,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Catégorie du produit",
            valeurString: newState[ReclamationQualificationDetailCodes.SavByFoussierCategorie].libelle,

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierCategorie);


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavTypeProduit,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Nom commercial du produit",
            valeurString: newState[ReclamationQualificationDetailCodes.DetailSavTypeProduit],

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavTypeProduit);


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavMarque,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Marque",
            valeurString: newState[ReclamationQualificationDetailCodes.DetailSavMarque].nom,

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavMarque);


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.SavByFoussierCodeArticle,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Code article",
            valeurString: newState[ReclamationQualificationDetailCodes.SavByFoussierCodeArticle],

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierCodeArticle);


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavNumeroSerie,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "N° de série",
            valeurString: newState[ReclamationQualificationDetailCodes.DetailSavNumeroSerie],

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavNumeroSerie);


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavDateAchat,
            type: ReclamationQualificationDetailType.Date,
            libelle: "Date d'achat",
            valeurDate: newState[ReclamationQualificationDetailCodes.DetailSavDateAchat],

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavDateAchat);


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavAnneeProductionMachine,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Date de production de la machine",
            valeurString: newState.anneeProductionMachine !== null ?
                `${newState.anneeProductionMachine.getFullYear()}` :
                newState.anneeProductionMachineLisible ? "Illisible" : "",

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavAnneeProductionMachine);


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie,
            type: ReclamationQualificationDetailType.Date,
            libelle: "Date de fin de garantie",
            valeurDate: newState[ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie],

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie);


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavBLOuFacture,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "N° BL ou facture",
            valeurString: newState[ReclamationQualificationDetailCodes.DetailSavBLOuFacture],

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavBLOuFacture);


        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavMotif,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Descriptif de la panne",
            valeurString: newState[ReclamationQualificationDetailCodes.DetailSavMotif],

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavMotif);



        return {
            name: newState.name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }


    render() {
        const { name, nonFoussierHorsGarantie, fournisseurId } = this.props;

        return (

            <Accordion id={name} defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Produit" />

                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>

                    <Stack spacing={1} mt={1}>

                        <SAVCategorieSelect
                            name={ReclamationQualificationDetailCodes.SavByFoussierCategorie}
                            value={this.state[ReclamationQualificationDetailCodes.SavByFoussierCategorie]}
                            onChange={this.handleChange}
                        />


                        <QualificationTextField
                            label={"Nom commercial du produit"}
                            name={ReclamationQualificationDetailCodes.DetailSavTypeProduit}
                            value={this.state[ReclamationQualificationDetailCodes.DetailSavTypeProduit]}
                            onChange={this.handleChange}
                            required
                        />

                        <MarquesSelect
                            name={ReclamationQualificationDetailCodes.DetailSavMarque}
                            value={this.state[ReclamationQualificationDetailCodes.DetailSavMarque]}
                            onChange={this.handleChange}
                            fournisseurId={fournisseurId}
                        />


                        <QualificationTextField
                            label={"Code article visible sur le produit"}
                            name={ReclamationQualificationDetailCodes.SavByFoussierCodeArticle}
                            value={this.state[ReclamationQualificationDetailCodes.SavByFoussierCodeArticle]}
                            onChange={this.handleChange}
                            required
                        />


                        <QualificationTextField
                            label={"N° de série"}
                            name={ReclamationQualificationDetailCodes.DetailSavNumeroSerie}
                            value={this.state[ReclamationQualificationDetailCodes.DetailSavNumeroSerie]}
                            onChange={this.handleChange}
                            required
                        />

                        <Stack direction='row' spacing={3} alignItems="center">
                            <MyDatePicker
                                label={'Année de production de la machine'}
                                value={this.state.anneeProductionMachine}
                                onChange={(value) =>
                                    this.handleChangeAnneeProductionMachine(value)
                                }
                                required
                                views={['year']}
                                format='yyyy'
                                toolbarFormat='yyyy'
                                minDate={new Date('2000-01-01')}
                                maxDate={new Date()}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.anneeProductionMachineLisible}
                                        onChange={(event) =>
                                            this.handleChangeAnneeProductionMachine(event.target.checked)
                                        }
                                    />
                                }
                                label="Date de production illisible"
                            />
                        </Stack>

                        <MyDatePicker
                            label={"Date d'achat"}
                            value={this.state[ReclamationQualificationDetailCodes.DetailSavDateAchat]}
                            onChange={value => this.handleChangeDateAchat({ target: { name: ReclamationQualificationDetailCodes.DetailSavDateAchat, value: value } })}
                            disableFuture={true}
                            fullWidth
                            required={!nonFoussierHorsGarantie}
                        />

                        <MyDatePicker
                            label={"Date de fin de garantie"}
                            value={this.state[ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie]}
                            onChange={value => this.handleChange({ target: { name: ReclamationQualificationDetailCodes.SavByFoussierDateFinGarantie, value: value } })}
                            fullWidth
                            required={!nonFoussierHorsGarantie}
                        />

                        <QualificationTextField
                            label={"N° BL ou facture"}
                            name={ReclamationQualificationDetailCodes.DetailSavBLOuFacture}
                            value={this.state[ReclamationQualificationDetailCodes.DetailSavBLOuFacture]}
                            onChange={this.handleChange}
                            required={!nonFoussierHorsGarantie}
                        />

                        <QualificationTextField
                            label={"Descriptif de la panne"}
                            name={ReclamationQualificationDetailCodes.DetailSavMotif}
                            value={this.state[ReclamationQualificationDetailCodes.DetailSavMotif]}
                            onChange={this.handleChange}
                            required
                            multiline
                            placeholder={"Merci de bien détailler pour aider le fabricant à identifier la panne réelle."}
                        />
                    </Stack>

                </AccordionDetails>
            </Accordion>

        );
    }

}


SavByFoussierProduit.propTypes = {
    name: PropTypes.string.isRequired,
    delaiReference: PropTypes.number.isRequired,
    nonFoussierHorsGarantie: PropTypes.bool.isRequired,
    fournisseurId: PropTypes.number.isRequired,
};

//SavByFoussierProduit.defaultProps = {
//};

export default SavByFoussierProduit;